export const GA_TRACKING_ID = 'G-YCRF742TW0';

export const initializeAnalytics = (hasConsent) => {
  if (window.gtag) {
    window.gtag('consent', 'update', {
      'analytics_storage': hasConsent ? 'granted' : 'denied'
    });
  }
};

export const pageview = (url) => {
  if (window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: url,
      send_to: GA_TRACKING_ID
    });
  }
};

export const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, {
      ...params,
      send_to: GA_TRACKING_ID
    });
  }
};

export const ANALYTICS_EVENTS = {
  REGISTRATION_START: 'registration_start',
  REGISTRATION_COMPLETE: 'registration_complete',
  REGISTRATION_ERROR: 'registration_error',
  LOGIN: 'login',
  LOGIN_ERROR: 'login_error',
  PASSWORD_RESET_REQUEST: 'password_reset_request',
  CONTEST_ENTRY: 'contest_entry',
  MARKETING_CONSENT: 'marketing_consent',
  COOKIE_CONSENT: 'cookie_consent',
  COOKIE_SETTINGS_CHANGE: 'cookie_settings_change'
}; 